/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import manasLogo from "../../assets/Logos/manas-with-border.png";
import manasMotto from "../../assets/Logos/manas-motto.svg";
import manasFull from "../../assets/Logos/manas-full-white.png";

import { useEffect, useRef } from "react";
import * as THREE from "three";

export default function Landing() {
  const mountRef = useRef(null);

  var particles,
    particle,
    count = 0;

  // var windowHalfX = window.innerWidth / 2;
  // var windowHalfY = window.innerHeight / 2;

  var SEPARATION = 40,
    AMOUNTX = 130,
    AMOUNTY = 35;

  var camera, scene, renderer;

  useEffect(() => {
    camera = new THREE.PerspectiveCamera(
      120,
      window.innerWidth / window.innerHeight,
      1,
      10000
    );

    camera.position.y = 400;
    camera.position.z = 200;

    camera.rotation.x = 0.35;

    scene = new THREE.Scene();

    // eslint-disable-next-line no-array-constructor
    particles = new Array();

    const map = new THREE.TextureLoader().load("disc.png");

    var material = new THREE.SpriteMaterial({
      map: map,
      color: 0xffffff,
    });

    var i = 0;

    for (var ix = 0; ix < AMOUNTX; ix++) {
      for (var iy = 0; iy < AMOUNTY; iy++) {
        particle = particles[i++] = new THREE.Sprite(material);

        particle.position.x =
          ix * SEPARATION - (AMOUNTX * SEPARATION) / 2;

        particle.position.z =
          iy * SEPARATION -
          (AMOUNTY * SEPARATION - 10);

        scene.add(particle);
      }
    }

    renderer = new THREE.WebGLRenderer();

    renderer.setSize(
  mountRef.current.clientWidth,
  mountRef.current.clientHeight
  );

    renderer.setClearColor(0x071013, 1);

    mountRef.current.appendChild(renderer.domElement);


    // ------------------------------------
    // FPS-INDEPENDENT ANIMATION
    // ------------------------------------

    let lastTime = performance.now();

    var animate = function (currentTime) {
      requestAnimationFrame(animate);

      // Time passed since the previous frame
      let deltaTime =
        (currentTime - lastTime) / 1000;

      lastTime = currentTime;

      // Prevent large jumps when the tab
      // was inactive or the device lagged
      deltaTime = Math.min(deltaTime, 0.1);

      var i = 0;

      for (var ix = 0; ix < AMOUNTX; ix++) {
        for (var iy = 0; iy < AMOUNTY; iy++) {
          particle = particles[i++];

          particle.position.y =
            Math.sin((ix + count) * 0.5) * 20 +
            Math.sin((iy + count) * 0.5) * 20;

          particle.scale.x =
            particle.scale.y =
              (Math.sin((ix + count) * 0.3) + 2) *
                2.5 +
              (Math.sin((iy + count) * 0.5) + 1) *
                2.5;
        }
      }

      renderer.render(scene, camera);

      count += 12 * deltaTime;
    };

    animate(performance.now());

  }, []);

  return (
    <>
      <div
  className="landing-manas"
  id="landing"
  style={{
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    background: "#071013",
  }}
>

        <div
  className="logo"
  ref={mountRef}
  style={{
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    overflow: "hidden",
  }}
>
          <img
            src={manasLogo}
            alt={"Project Manas"}
          />

          <img
            src={manasMotto}
            alt={"Project Manas"}
          />

          <img
            src={manasFull}
            alt={"Project Manas"}
          />
        </div>
      </div>
    </>
  );
}